import { useState, useEffect } from 'react';
import Label from '../Label';
import DialCode from './DialCode';
import './TextInput.scss';

const TextInput = ({
  className,
  label,
  type,
  error,
  isRequired,
  placeholder,
  onChange,
  name,
  value,
  reference,
  id,
  disabled,
  labelClass,
  autoFocus,
  isPhoneNumber,
  phoneNumberData,
  handelCancel,
  onBlur,
  IsIcon,
  icon,
  isBadge,
  suggestions = [],
  badgeStyle,
  readonly = false,
  rightIconElement,
}) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    document.addEventListener('wheel', (event) => {
      if (
        document.activeElement.type === 'number' &&
        document.activeElement.classList.contains('noscroll')
      ) {
        document.activeElement.blur();
      }
    });
  }, []);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setInputValue(inputValue);
    onChange(e);

    if (inputValue) {
      const filtered = suggestions.filter((s) =>
        s.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowDropdown(filtered.length > 0);
    } else {
      // setFilteredSuggestions(suggestions);
      // setShowDropdown(true);
      setFilteredSuggestions([]);
      setShowDropdown(false);
    }
  };

  const handleInputFocus = () => {
    if (suggestions.length > 0) {
      setFilteredSuggestions(suggestions);
      // setShowDropdown(true);
      setShowDropdown(suggestions.length > 0);
    }
  };

  const handleInputBlur = () => {
    setTimeout(() => {
      if (!document.querySelector('.suggestions-dropdown:hover')) {
        setShowDropdown(false);
      }
    }, 200);
  };

  const handleSuggestionClick = (selectedValue) => {
    setInputValue(selectedValue);
    onChange({ target: { name: id, value: selectedValue } });
    setShowDropdown(false);
  };

  return (
    <div id="TextInput-container" className="position-relative">
      {label && (
        <Label label={label} required={isRequired} className={labelClass} />
      )}
      {isBadge && (
        <span className="label-badge" style={badgeStyle}>
          Updated
        </span>
      )}

      <div className="input-container">
        <div className="d-flex align-items-center">
          {isPhoneNumber && (
            <DialCode
              onChange={onChange}
              phoneNumberData={phoneNumberData}
              disabled={disabled}
            />
          )}
          <div className="flex-grow-1 position-relative">
            {IsIcon && (
              <div className="icon-wrapper" style={{ width: '24px' }}>
                <img src={icon} alt="outline" />
              </div>
            )}
            <input
              id={id}
              autoComplete="off"
              placeholder={placeholder}
              name={name}
              type={type || 'text'}
              className={`noscroll text-truncate ${className || 'text-input'} ${
                isPhoneNumber ? 'border-start-0 phone-redius' : ''
              } ${handelCancel ? 'button-padding' : ''} ${rightIconElement ? 'has-right-icon' : ''}`}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              onBlur={(e) => {
                if (onBlur) onBlur(e);
                handleInputBlur(e);
              }}
              value={inputValue}
              ref={reference}
              disabled={disabled}
              autoFocus={autoFocus}
              style={{
                paddingLeft: IsIcon ? '35px' : '16px',
                paddingRight: rightIconElement ? '45px' : undefined,
              }}
              readOnly={readonly}
            />
            {/* Right Icon Element */}
            {rightIconElement && (
              <div className="right-icon-wrapper">{rightIconElement}</div>
            )}
            {/* Suggestions dropdown */}
            {showDropdown && (
              <ul className="suggestions-dropdown">
                <p className="text-16-600-24 cpt-5 cps-15 cmb-5">
                  Recently Used :
                </p>
                {filteredSuggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onMouseDown={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {handelCancel && (
          <div
            className="cancel-block"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handelCancel();
            }}
          >
            Cancel
          </div>
        )}

        {error && (
          <span className="text-13-400 pt-1 d-flex align-items-center gap-2">
            <span style={{ color: 'red' }}>{error}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default TextInput;

// import { useEffect } from "react";
// import Label from "../Label";
// import DialCode from "./DialCode";
// import "./TextInput.scss";

// const TextInput = ({
//   className,
//   label,
//   type,
//   error,
//   isRequired,
//   placeholder,
//   onChange,
//   name,
//   value,
//   reference,
//   id,
//   disabled,
//   labelClass,
//   autoFocus,
//   isPhoneNumber,
//   phoneNumberData,
//   handelCancel,
//   onBlur,
//   IsIcon,
//   icon,
//   isBadge,
// }) => {
//   useEffect(() => {
//     document.addEventListener("wheel", (event) => {
//       if (
//         document.activeElement.type === "number" &&
//         document.activeElement.classList.contains("noscroll")
//       ) {
//         document.activeElement.blur();
//       }
//     });
//   }, []);
//   return (
//     <div id="TextInput-container" className="position-relative">
//       {label && (
//         <Label label={label} required={isRequired} className={labelClass} />
//       )}
//       {isBadge && <span className="label-badge">Updated</span>}
//       <div className="input-container">
//         <div className="d-flex align-items-center">
//           {isPhoneNumber && (
//             <DialCode
//               onChange={onChange}
//               phoneNumberData={phoneNumberData}
//               disabled={disabled}
//             />
//           )}
//           <div className="flex-grow-1">
//             {IsIcon && (
//               <div className="icon-wrapper" style={{ width: "24px" }}>
//                 <img src={icon} alt="outline" />
//               </div>
//             )}
//             <input
//               id={id}
//               autoComplete="off"
//               placeholder={placeholder}
//               name={name}
//               type={type || "text"}
//               className={`noscroll text-truncate ${className || "text-input"} ${
//                 isPhoneNumber ? "border-start-0 phone-redius" : ""
//               } ${handelCancel ? "button-padding" : ""}`}
//               onChange={onChange}
//               onBlur={onBlur}
//               value={value}
//               ref={reference}
//               disabled={disabled}
//               autoFocus={autoFocus}
//               style={{ paddingLeft: IsIcon ? "35px" : "16px" }}
//             />
//           </div>
//         </div>
//         {handelCancel && (
//           <div
//             className="cancel-block"
//             onClick={(e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               handelCancel();
//             }}
//           >
//             Cancel
//           </div>
//         )}

//         {error && (
//           <span className="text-13-400 pt-1 d-flex align-items-cemter gap-2">
//             <span style={{ color: "red" }}>{error}</span>
//           </span>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TextInput;
